import React from 'react';
import PropTypes from 'prop-types';
import { H2Alt, AccentH3, Paragraph } from 'scy/text';
import { textCenter } from 'scy/utils.mod.scss';
import { flex, wrap, centerContent, spaceBetween } from 'scy/flex.mod.scss';
import classnames from 'classnames';
import padding from 'scy/padding.mod.scss';
import styles from './styles.mod.scss';
import { config } from './config';

const Reasons = ({ city }) => (
  <Section title={insertCity(config.reasons.title, city)}>
    <SubSection>
      <SubSectionItems
        items={config.reasons.list_items}
        city={{ code: city.code, name: city.name }}
        accent
      />
    </SubSection>
  </Section>
);

const Section = ({ title, children }) => {
  return (
    <div
      className={classnames(
        padding.left_lg,
        padding.right_lg,
        padding.top_md,
        padding.bottom_lg
      )}
    >
      <H2Alt className={classnames(textCenter, padding.bottom_md)}>
        {title}
      </H2Alt>
      {children}
    </div>
  );
};

const SubSection = ({ children }) => (
  <div
    className={classnames(
      flex,
      wrap,
      spaceBetween,
      centerContent,
      styles.subSection,
      textCenter
    )}
  >
    {children}
  </div>
);

const SubSectionItems = ({ city, items }) =>
  items.map(reason => (
    <SubSectionItem key={`reason-${reason.subtitle}`}>
      <AccentH3>{insertCity(reason.subtitle, city)}</AccentH3>
      <Paragraph className={styles.paragraph}>
        {insertCity(reason.description, city)}
      </Paragraph>
    </SubSectionItem>
  ));

const SubSectionItem = ({ children }) => {
  return <div className={styles.subSectionItem}>{children}</div>;
};

Reasons.propTypes = {
  city: PropTypes.object
};

const insertCity = (str, city) => {
  if (!str) return;
  if (!city) return str;
  return str.replace(/##name/gim, city.name).replace(/##code/gim, city.code);
};

export { Section, SubSection, SubSectionItem, insertCity };
export default Reasons;
